import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { LOGO } from "@/lib/assets";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Connexion impossible");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#6f7d54] flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO} alt="Island Camps" className="h-14 mx-auto mb-4" />
          <p className="font-body text-[#f7efe0]/70">Espace administration</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-2xl">
          <h1 className="font-head font-bold text-2xl text-[#6f7d54] mb-6 flex items-center gap-2"><Lock size={22} className="text-[#e07a5f]" /> Connexion</h1>
          {error && <div data-testid="admin-login-error" className="bg-[#e63946]/10 text-[#b5232f] rounded-xl px-4 py-3 mb-4 font-body font-semibold text-sm">{error}</div>}
          <label className="block mb-4">
            <span className="font-body font-semibold text-sm text-[#3a4d68] block mb-1.5">E-mail</span>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-[#6f7d54]/15 px-4 py-3 font-body outline-none focus:border-[#e07a5f]" required />
          </label>
          <label className="block mb-6">
            <span className="font-body font-semibold text-sm text-[#3a4d68] block mb-1.5">Mot de passe</span>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-[#6f7d54]/15 px-4 py-3 font-body outline-none focus:border-[#e07a5f]" required />
          </label>
          <button data-testid="admin-login-submit" disabled={loading} className="w-full rounded-full bg-[#e07a5f] hover:bg-[#cf6a50] disabled:opacity-50 text-white font-bold px-6 py-3.5 flex items-center justify-center gap-2 transition-colors">
            {loading ? <Loader2 className="animate-spin" size={20} /> : null} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
